export enum SimpleAppointmentStatus{
    CANCELLED = "CANCELLED", 
    COMPLETED = "COMPLETED", 
    CONFIRMED = "CONFIRMED", 
    PENDING = "PENDING"
}

export class SimpleRequest{
    date: string;
    
}

export class SimpleRequestStatus{
    appointmentStatus: SimpleAppointmentStatus;
    
}

export class SimpleRequestSearch{
    appointmentStatus: SimpleAppointmentStatus;
    reservationDate: string;
    pageNumber: number;
    pageSize: number;
    sortBy: string;
    appointmentDate: string;
    storeId: number;
    topicId: number;
    city: string;
    address: string;
    
}